import { buildSuccessAppleEmailChangePayload } from './buildSuccessAppleEmailChangePayload.js';
export const trackAppleEmailChangeSuccessfulRequest = (params) => buildSuccessAppleEmailChangePayload(params);
//# sourceMappingURL=trackAppleEmailChangeSuccessfulRequest.js.map